"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableContentAnimations = disableContentAnimations;
exports.enablePresenterAnimations = enablePresenterAnimations;
exports.findSoloSource = findSoloSource;
exports.findSourceByType = findSourceByType;
exports.getFeaturedMediaOrScreen = getFeaturedMediaOrScreen;
exports.getSourceByType = getSourceByType;
exports.getSourceCountByType = getSourceCountByType;
exports.hasOneCameraPresenter = hasOneCameraPresenter;
exports.hasOneMediaSource = hasOneMediaSource;
exports.hasOneScreenPresenter = hasOneScreenPresenter;
exports.isFeaturedMediaOrScreen = isFeaturedMediaOrScreen;
exports.isSameSource = isSameSource;
exports.isSceneLayer = isSceneLayer;
exports.isSceneLayout = isSceneLayout;
exports.isSolo = isSolo;
exports.isSoloCameraPresenter = isSoloCameraPresenter;
exports.isSoloMedia = isSoloMedia;
exports.isSoloScreenPresenter = isSoloScreenPresenter;
exports.replaceSource = replaceSource;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Sources = require("@studio/constants/Sources");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _utils = require("../utils");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Formerly, the scene layout type was saved in the id property of the scene
 * We also have scene layout type now saved in the layout property of the scene
 * @param {{}} scene
 * @param {{}} layout
 */
function isSceneLayout(scene, layout) {
  if (Array.isArray(layout)) {
    return layout.includes(scene._id);
  }
  return scene._id === layout.id || (scene === null || scene === void 0 ? void 0 : scene.layout) === layout.id;
}

/**
 * @param {{}} scene
 */
function isFeaturedMediaOrScreen(scene) {
  return isSceneLayout(scene, _SceneLayouts.FEATURED_MEDIA) || isSceneLayout(scene, _SceneLayouts.FEATURED_SCREEN);
}

/**
 * @param {{}} source1
 * @param {{}} source2
 */
function isSameSource(source1, source2) {
  var _source1$source, _source2$source;
  return ((_source1$source = source1.source) === null || _source1$source === void 0 ? void 0 : _source1$source._id) === ((_source2$source = source2.source) === null || _source2$source === void 0 ? void 0 : _source2$source._id);
}

/**
 * Replace a source in program with a new source
 * @param {{}} scene - current scene
 * @param {string} sourceId - source id of the source to be replaced
 * @param {{}} newSource - new source
 * @returns scene
 */
function replaceSource() {
  var scene = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sourceId = arguments.length > 1 ? arguments[1] : undefined;
  var newSource = arguments.length > 2 ? arguments[2] : undefined;
  var newScene = _objectSpread({}, scene);
  newScene.layers = scene.layers.map(function (layerSource) {
    return layerSource._id === sourceId ? newSource : layerSource;
  });
  return newScene;
}

/**
 * Find a solo source
 * @param {{}} scene
 * @returns a layer source or undefined
 */
function findSoloSource(scene) {
  var layers = (0, _utils.getProgramLayers)(scene);
  return layers === null || layers === void 0 ? void 0 : layers.find(function (layerSource) {
    return !isSceneLayer(layerSource);
  });
}

/**
 * Find source by type
 * @param {{}} scene: Current scene
 * @param {string} sourceType: source type to check in a scene
 * @returns Layer or undefined
 */
function findSourceByType(scene, sourceType) {
  var layers = (0, _utils.getProgramLayers)(scene);
  return layers === null || layers === void 0 ? void 0 : layers.find(function (layerSource) {
    var _layerSource$source;
    return (layerSource === null || layerSource === void 0 || (_layerSource$source = layerSource.source) === null || _layerSource$source === void 0 ? void 0 : _layerSource$source.type) === sourceType;
  });
}

/**
 * @param {{}} scene
 * @param {string} sourceType
 */
function getSourceByType(scene, sourceType) {
  var layers = (0, _utils.getProgramLayers)(scene);
  return layers.filter(function (layerSource) {
    var _layerSource$source2;
    return (layerSource === null || layerSource === void 0 || (_layerSource$source2 = layerSource.source) === null || _layerSource$source2 === void 0 ? void 0 : _layerSource$source2.type) === sourceType && !isSceneLayer(layerSource);
  });
}

/**
 * @param {{}} scene
 * @param {string} sourceType
 */
function getSourceCountByType(scene, sourceType) {
  var layers = (0, _utils.getProgramLayers)(scene);
  if (layers !== null && layers !== void 0 && layers.length) {
    var matches = layers.filter(function (layerSource) {
      var _layerSource$source3;
      return (layerSource === null || layerSource === void 0 || (_layerSource$source3 = layerSource.source) === null || _layerSource$source3 === void 0 ? void 0 : _layerSource$source3.type) === sourceType && !isSceneLayer(layerSource);
    });
    return matches.length;
  }
  return 0;
}

/**
 * @param {{}} scene
 * @param {Function} predicate
 */
function isSolo(scene, predicate) {
  var _scene$layers;
  if (scene !== null && scene !== void 0 && scene.layers && (_scene$layers = scene.layers) !== null && _scene$layers !== void 0 && _scene$layers.length) {
    return isSceneLayout(scene, _SceneLayouts.SINGLE) && predicate(scene);
  }
  return false;
}

/**
 * @param {{}} scene
 */
function isSoloScreenPresenter(scene) {
  return isSolo(scene, hasOneScreenPresenter);
}

/**
 * @param {{}} scene
 */
function isSoloCameraPresenter(scene) {
  return isSolo(scene, hasOneCameraPresenter);
}

/**
 * @param {{}} scene
 */
function isSoloMedia(scene) {
  return isSolo(scene, hasOneMediaSource);
}

/**
 * @param {{}} scene
 */
function hasOneMediaSource(scene) {
  return getSourceCountByType(scene, _Sources.IMAGE_FILE) + getSourceCountByType(scene, _Sources.PDF_FILE) + getSourceCountByType(scene, _Sources.VIDEO_FILE) === 1;
}

/**
 * @param {{}} scene
 */
function hasOneScreenPresenter(scene) {
  return getSourceCountByType(scene, _Sources.SCREEN_PRESENTER) === 1;
}

/**
 * @param {{}} scene
 */
function hasOneCameraPresenter(scene) {
  return getSourceCountByType(scene, _Sources.CAMERA_PRESENTER) === 1;
}

/**
 * Determine if a source is an overlay, background or banner
 * @param {{}} source
 */
function isSceneLayer(source) {
  var _source$layer;
  // overlays, backgrounds and banners have "layer.isContent" property set to false
  return (source === null || source === void 0 || (_source$layer = source.layer) === null || _source$layer === void 0 ? void 0 : _source$layer.hasOwnProperty('isContent')) && source.layer.isContent === false;
}

/**
 * @param {{}} scene
 */
function getFeaturedMediaOrScreen(scene) {
  if (isFeaturedMediaOrScreen && scene && scene.layers) {
    return scene.layers.find(function (layerSource) {
      var _layerSource$source4;
      return (layerSource === null || layerSource === void 0 || (_layerSource$source4 = layerSource.source) === null || _layerSource$source4 === void 0 ? void 0 : _layerSource$source4.type) !== _Sources.CAMERA_PRESENTER && !isSceneLayer(layerSource);
    });
  }
}

/**
 * @param {{}} scene
 */
function enablePresenterAnimations(scene) {
  var next = scene;
  var nextCameraPresenters = getSourceByType(scene, _Sources.CAMERA_PRESENTER);
  var _iterator = _createForOfIteratorHelper(nextCameraPresenters),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var camera = _step.value;
      camera.layer.animation.transition = _utils.DEFAULT_ANIMATION.transition;
      next = replaceSource(next, camera._id, camera);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return next;
}

/**
 * Disable animations for layer sources that are content i.e. they're not
 * overlays, backgrounds or banners.
 * @param {{}} scene
 * @param  sourceTypes
 * @returns {{}}
 */
function disableContentAnimations(scene) {
  var _scene$layers2;
  var sourceTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  scene.layers = (_scene$layers2 = scene.layers) === null || _scene$layers2 === void 0 ? void 0 : _scene$layers2.map(function (layerSource) {
    var _layerSource$source5;
    if (sourceTypes.includes(layerSource === null || layerSource === void 0 || (_layerSource$source5 = layerSource.source) === null || _layerSource$source5 === void 0 ? void 0 : _layerSource$source5.type) && !isSceneLayer(layerSource)) {
      layerSource.layer.animation.transition = _utils.HARD_CUT_ANIMATION.transition;
      return layerSource;
    }
    return layerSource;
  });
  return scene;
}